// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"76e3d782","455":"7abf1460","977":"cadafc8d"}[chunkId] + ".chunk.js";
};